import { Form, Formik } from "formik";
import toast from "react-hot-toast";
import { Link, useNavigate } from "react-router-dom";
import { Col, Row, Spinner } from "reactstrap";
import Logo from "../../../assets/images/logo.png";
import FormInput from "../../../components/FormInput";
import { register } from "./register-page.service";
import { validationSchema } from "./register-page.validation";

export default function RegisterPage() {
  const navigate = useNavigate();
  const handleRegister = (values: any, actions: any) => {
    register(values)
      .then((response) => {
        actions.setSubmitting(false);
        toast.success(response.data.message);
        navigate("/login");
      })
      .catch((err) => {
        actions.setSubmitting(false);
        toast.error(err.response.data.message);
      });
  };
  return (
    <section
      style={{
        backgroundColor: "white",
        backgroundImage:
          "url('https://d3fgk2078as9ko.cloudfront.net/assets/login.jpg')",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
      }}
      className="ec-page-content section-space-p"
    >
      <div className="container">
        <div className="row">
          <div
            className="ec-login-wrapper"
            style={{
              maxWidth: "800px",
            }}
          >
            <div className="ec-login-container">
              <div className="account_form">
                <div className="text-center">
                  <img width="100px" src={Logo} />
                </div>
                <div className="text-center">
                  <h3>Welcome to</h3>
                  <h3
                    style={{
                      fontWeight: "bold",
                    }}
                  >
                    Prince Art Exporter
                  </h3>
                  <h5>One Of A Kind Store</h5>
                </div>
              </div>
              <div className="ec-login-form">
                <Formik
                  validationSchema={validationSchema}
                  initialValues={{
                    companyName: "",
                    firstName: "",
                    lastName: "",
                    email: "",
                    contactNo: "",
                    country: "",
                  }}
                  onSubmit={handleRegister}
                >
                  {({
                    handleChange,
                    handleBlur,
                    errors,
                    values,
                    touched,
                    isSubmitting,
                  }) => (
                    <Form>
                      <Row>
                        <Col md={6}>
                          <FormInput
                            label="Company Name"
                            placeholder="Company Name"
                            name="companyName"
                            type="text"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.companyName}
                            error={errors.companyName}
                            touched={touched.companyName}
                            isRequired={false}
                            className={""}
                          />
                        </Col>
                        <Col md={6}>
                          <FormInput
                            label="First Name"
                            placeholder="First Name"
                            name="firstName"
                            type="text"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.firstName}
                            error={errors.firstName}
                            touched={touched.firstName}
                            isRequired={false}
                            className={""}
                          />
                        </Col>
                        <Col md={6}>
                          <FormInput
                            label="Last Name"
                            placeholder="Last Name"
                            name="lastName"
                            type="text"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.lastName}
                            error={errors.lastName}
                            touched={touched.lastName}
                            isRequired={false}
                            className={""}
                          />
                        </Col>
                        <Col md={6}>
                          <FormInput
                            label="Email ID"
                            placeholder="Email ID"
                            name="email"
                            type="text"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.email}
                            error={errors.email}
                            touched={touched.email}
                            isRequired={false}
                            className={""}
                          />
                        </Col>
                        <Col md={6}>
                          <FormInput
                            label="Contact No"
                            placeholder="Contact No"
                            name="contactNo"
                            type="text"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.contactNo}
                            // error={errors.contactNo}
                            touched={touched.contactNo}
                            isRequired={false}
                            error={undefined}
                            className={""}
                          />
                        </Col>
                        <Col md={6}>
                          <FormInput
                            label="Country Name"
                            placeholder="Country Name"
                            name="country"
                            type="text"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.country}
                            error={errors.country}
                            touched={touched.country}
                            isRequired={false}
                            className={""}
                          />
                        </Col>
                      </Row>

                      <div className="login_submit">
                        <button
                          className="btn btn-primary"
                          type="submit"
                          disabled={isSubmitting}
                        >
                          {isSubmitting ? (
                            <Spinner
                              as="span"
                              animation="border"
                              size="sm"
                              role="status"
                              aria-hidden="true"
                            />
                          ) : (
                            "Submit"
                          )}
                        </button>
                      </div>
                    </Form>
                  )}
                </Formik>
                <div className="text-center mt-3">
                  <span>
                    Back to <Link to="/login">Login</Link>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
